import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { getLoginRedirect } from "../../Utils/redirectUtils";
import Loading from "../Loading/Loading";

export function LoginRedirection() {
  const navigate = useNavigate();
  const { redirect_id } = useParams();
  console.log(window.location);
  window.scrollTo(0, 0);
  useEffect(() => {
    if (!redirect_id) return navigate("/login", { replace: true });
    try {
      getLoginRedirect(redirect_id)
        .then((res) => {
          let username;
          if (res.status !== 200) navigate("/login", { replace: true });
          else {
            res
              .json()
              .then((data) => {
                username = data?.username;
              })
              .finally(() => {
                console.log("Ejecutando....");
                window?.sessionStorage?.setItem("ostreon_username", username);
                return navigate("/login", { replace: true });
              });
          }
        })
        .catch((e) => {
          console.log(e);

          navigate("/login", { replace: true });
        });
    } catch (error) {
      console.log(error);
      navigate("/login", { replace: true });
    }
  }, []);

  return (
    <div style={{ height: "500px" }}>
      <Loading text={"Loading"}></Loading>
    </div>
  );
}
